// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  environment: 'development',
  // App version — single source of truth for cache-busting / forced refresh.
  // Bump this on every release. It is baked into the bundle at build time and
  // compared against the freshly-served /version.json by VersionCheckService.
  version: '2.51.0',
  reportViewerURL: 'https://live.solbox.it/', // s/be live
  sentryDsn:
    'https://bb7265c8af284f139e51ce9b3b1d79d2@o381818.ingest.sentry.io/4505429415034881',
  googleAnalyticsId: undefined,
  workspacePlans: true,
  // Cutover date (YYYY-MM-DD) for the manifest "Actual" sequence tab.
  // Manifests with a ManifestDate on or before this date are shown with the
  // Actual tab disabled, since actual-sequence tracking data isn't reliable
  // for manifests scheduled before this feature was deployed.
  manifestActualTabDeploymentDate: '2026-08-04',
};
